import { ERROR_CHECKIN_NEEDED, missionPLatField,
  missionPLngField } from '../../../../utils/constants'

export default (page, { answer = {} }) => {
  const has_answer = answer[missionPLatField(page)] && answer[missionPLngField(page)]
  return {
    valid: !!has_answer,
    is_correct_answer: true,
    errors: has_answer ? new Set() : new Set([
      ERROR_CHECKIN_NEEDED,
    ]),
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Missions/Progress/validators/checkin.jsx